import { tryParse } from 'utils';
import {
	FETCH_CHECKLISTS,
	FETCH_CHECKLISTS_FAILED,
	CLEAR_CHECKLISTS,
	UPSERT_CHECKLIST,
	REMOVE_CHECKLIST,
} from '../actions/actionTypes';

const preState = { checklists: [], loaded: false, loadFailed: false };

const normalize = checklist => ({ ...checklist, content: tryParse(checklist.content) });
const byName = (a, b) => a.name.localeCompare(b.name);

const checklistsReducer = (state = preState, action) => {
	switch (action.type) {
		case FETCH_CHECKLISTS:
			return {
				...state,
				checklists: action.checklists.map(normalize).sort(byName),
				loaded: true,
				loadFailed: false,
			};
		case FETCH_CHECKLISTS_FAILED:
			return { ...state, loaded: true, loadFailed: true };
		case CLEAR_CHECKLISTS:
			return preState;
		case UPSERT_CHECKLIST: {
			const checklist = normalize(action.checklist);
			const rest = state.checklists.filter(c => c.id !== checklist.id);
			return { ...state, checklists: [...rest, checklist].sort(byName) };
		}
		case REMOVE_CHECKLIST:
			return { ...state, checklists: state.checklists.filter(c => c.id !== action.checklistID) };
		default:
			return state;
	}
};

export default checklistsReducer;
